import { useEffect } from 'react'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'

const Redirect = ({ to }) => {
  useEffect(() => {
    window.location.assign(to)
  }, [])
  return <LinearProgress color="secondary" />
}

Redirect.propTypes = {
  to: PropTypes.string.isRequired,
}

export default Redirect
